import styled from "@rentiohq/shared-frontend/dist/components/theme/styled-components";
import { CONFIG } from "@rentiohq/shared-frontend/dist/config/app.config";
import { centerFormWrap } from "../../../../utils/styles.utils";

export const FormWrap = styled.div`
  ${centerFormWrap}
`;

export const SuccessText = styled.span`
  margin-top: 32px;
  font-size: 14px;
  line-height: 20px;
  color: ${props => props.theme.colors.neutral1};
  @media ${CONFIG.RESPONSIVE.BREAKPOINT.DESKTOP} {
    font-size: 16px;
    line-height: 23px;
  }
`;

export const ButtonInfo = styled.div`
  margin-right: 4px;
  font-size: 15px;
  color: ${props => props.theme.colors.neutral1};
  > * {
    float: left;
    margin: 0;
  }
`;
